import React from "react";
import PropTypes from "prop-types";
import {
    chunk as _chunk,
    reject as _reject,
    unescape as _unescape,
} from 'lodash';

import {Col} from "../../components/FoundationComponents";
import Post from "../../components/Post";

import Translation from "../../../commons/i18n/Translation";

/**
 * MyWort home page section with X latest posts.
 *
 * A "more" button let the user display another X latest posts, ordered by date
 */
export default class LatestPosts extends React.Component {

    static defaultProps = {
        elements: []
    };

    static propTypes = {
        elements            : PropTypes.array.isRequired,
        canShowMore         : PropTypes.bool,
        onClickMore         : PropTypes.func,
        onClickSearch       : PropTypes.func
    };


    // Display smaller posts if there are minimum 2 posts without picture
    getLayoutFromPosts = (posts) => (_reject(posts, 'futureOccurrences').length >= 3 && _reject(posts, 'mwTeaserMedium').length >= 3 )? Post.LAYOUTS.SMALL : Post.LAYOUTS.DEFAULT;

    renderPost = (post, layout = Post.LAYOUTS.DEFAULT, teaserPicture = post.mwTeaserMedium) => (
        <Post postId={post.id}
              publisherAvatarUri={post.publisher.avatarUrl}
              publisherPermalink={post.publisher.publicPermalink}
              publisherName={_unescape(post.publisher.fullName)}
              postTitle={_unescape(post.title)}
              postPermalink={post.permaLink}
              postType={post.style}
              publishedAt={post.publishedAt}
              localityName={post.locality.name}
              localityPermalink={post.localityPermalink}
              teaserPicture={teaserPicture}
              videoThumbnail={post.videoThumbnail}
              nextOccurrence={post.nextOccurrence}
              isGroup={post.publisher.isGroup}
              layout={layout}
              randomGradient={post.randomGradient}
              maybeMissionId={post.maybeMissionId} />
    );

    renderFirstRow = (posts) => {
        posts = posts.slice(0, 3);
        let layout = this.getLayoutFromPosts(posts);
        return (
            posts.map( (post, idx) =>
                <div className={"card-block__column pure-u-1 pure-u-lg-8-24 " + ( idx === 2 ? 'pure-u-md-24-24' : 'pure-u-md-12-24')} key={idx}>
                    { this.renderPost(post, layout) }
                </div>
            )
        );
    };

    renderHighlighItemTwoX = (posts) => {
        posts = posts.slice(3, 5);

        let firsPost = posts[0];
        let secondPost = posts[1];
        let fullPost;

        if(firsPost) {
            if(secondPost && secondPost.mwTeaserLarge) {
                fullPost = secondPost;
            } else {
                fullPost = firsPost;
            }
        }

        return (
            <Col className="card-block__column pure-u-1 pure-u-md-24-24 pure-u-lg-16-24">
                { fullPost ? this.renderPost(fullPost, Post.LAYOUTS.FULL, fullPost.mwTeaserLarge) : null }
            </Col>
        )
    };

    renderHighlighItemOneX = (posts) => {
        posts = posts.slice(3, 5);

        let firsPost = posts[0];
        let secondPost = posts[1];
        let defaultPost;

        if(firsPost) {
            if(secondPost && secondPost.mwTeaserLarge) {
                defaultPost = firsPost;
            } else if(secondPost) {
                defaultPost = secondPost;
            }
        }

        return (
            <Col className="card-block__column pure-u-1 pure-u-md-24-24 pure-u-lg-8-24">
                { defaultPost ? this.renderPost(defaultPost, Post.LAYOUTS.FULL) : null }
            </Col>
        )
    };

    renderThirdRow = (posts) => {
        posts = posts.slice(5, 8);
        let layout = this.getLayoutFromPosts(posts);

        return (
            posts.map( (post, idx) =>
                <Col className={"card-block__column pure-u-lg-8-24 " + ( idx === 2 ? 'pure-u-md-24-24' : 'pure-u-md-12-24')} key={idx}>
                    { this.renderPost(post, layout) }
                </Col>
            )
        );
    };

    renderFourthRow = (posts) => {
        posts = posts.slice(8, 11);
        let layout = this.getLayoutFromPosts(posts);

        return (
            posts.map( (post, idx) =>
            <Col className={"card-block__column pure-u-lg-8-24 " + ( idx === 2 ? 'pure-u-md-24-24' : 'pure-u-md-12-24')} key={post.id}>
                { this.renderPost(post, layout) }
            </Col>
            )
        );
    };

    render = () => {
        return (
            <div className="card-block">
                { _chunk(this.props.elements, 11).map( (posts, idx) => (
                    <div className="pure-g pure-g--gutters-mywort card-block__row card-block__row--internal" key={idx}>
                        {this.renderFirstRow(posts)}
                        {this.renderHighlighItemTwoX(posts)}
                        {this.renderHighlighItemOneX(posts)}
                        {this.renderThirdRow(posts)}
                        {this.renderFourthRow(posts)}
                    </div>
                ) ) }
                <div className="card-block__row card-block__row--center">
                    {this.props.canShowMore ? (
                        <button className="mywort-btn  u-mr-h" onClick={this.props.onClickMore}>
                            {Translation.translate("public.more")}
                        </button>
                    ) : null}
                    <button className="mywort-btn mywort-btn--outlined-orange" onClick={this.props.onClickSearch}>
                        {Translation.translate("public.search")}
                    </button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/post/LatestPosts.jsx